module.exports = __webpack_public_path__ + "img/but3.c58aeb2c.png";